import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button';
import Dialog, {
	DialogContent,
	DialogFooter,
	DialogTop
} from '@/components/Dialog';
import { useShallowEqualSelector } from '@/hooks';
import { useIsTrialing } from '@/hooks/user';
import SubscribeAddUser from '@/icons/subscribe-add-user.svg';
import routes from '@/routes';
import { setUpgradeToAddUsersModal } from '@/store/collaborators';

function UpgradeToAddUsersModal() {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const navigate = useNavigate();

	const isTrialing = useIsTrialing();

	const { isOpen } = useShallowEqualSelector(({ collaborators }) => ({
		isOpen: collaborators.upgradeToAddUsersModalOpen
	}));

	const messages = {
		guest: {
			title: t('users.upgradeModal.guestTitle'),
			description: t('users.upgradeModal.guestDescription')
		},
		trial: {
			title: t('users.upgradeModal.title'),
			description: t('users.upgradeModal.description')
		}
	};

	const currentMessages = messages?.[isTrialing ? 'trial' : 'guest'];

	const onClose = () => {
		dispatch(setUpgradeToAddUsersModal(false));
	};

	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent className="w-[280px] md:w-[397px]">
				<DialogTop title={currentMessages.title} />

				<div className="bg-White inline-flex flex-col items-center justify-center gap-1 self-stretch overflow-hidden px-4 py-9">
					<SubscribeAddUser />
					<div className="w-[249px] justify-center text-center text-sm leading-normal text-grey-500">
						{currentMessages.description}
					</div>
				</div>

				<DialogFooter>
					<Button
						type="button"
						variant="outline"
						onClick={event => {
							event.preventDefault();
							onClose(false);
						}}
					>
						{t('common.cancel')}
					</Button>
					<Button
						type="submit"
						loading={false}
						onClick={() => {
							onClose();
							navigate(routes.billing, {
								state: { openChangePlanModal: isTrialing }
							});
						}}
					>
						{t('users.upgradeModal.button')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default UpgradeToAddUsersModal;
